// extracted by mini-css-extract-plugin
export default {"MONTH":"Ec32f4","month":"Ec32f4","DAY":"OXl1b5","day":"OXl1b5","YEAR":"apFBxH","year":"apFBxH","fields":"cKbK5F","mobile":"ZaMVwG"};